import axios from 'axios';
import config from '@/helpers/config';

export default $axios => {
    return {
        $axios,

        async fetch() {
            return await axios.get(`${config.originalApiUrl}/clients/services`);
        }
    }
}